import { ReactComponent as IconDown } from "@/assets/svgs/icon-down.svg";
import { ReactComponent as IconNext } from "@/assets/svgs/icon-next.svg";
import iconSearch from "@/assets/svgs/icon-search.svg";
import { ReactComponent as IconCloseGrey } from "@/assets/svgs/iconCloseGrey.svg";
import { ReactComponent as IconNoDataDictionary } from "@/assets/svgs/no-data-dictionary.svg";
import MultiLineText from "@/components/MultiLineText/index";
import Search from '@/componentsDS/Search/index';
import Tags from '@/componentsDS/Tags/Tags';
import { useTradex } from "@/hooks/use-tradex/index";
import { feature, features as featureConstant } from "@/utils/feature-verifier";
import PropTypes from 'prop-types';
import { useState } from "react";

const bgColors =['#F9F9FF', "#EBEEF7", "#D7DAE3","#B0B3BC"]

export function NoMessage() {
	return (
		<div className="data-table__empty__icon">
			<IconNoDataDictionary />
			<span>Data Element not found in selected configuration.</span>
		</div>
	);
}

export function NoMessageUseCase() {
	return (
		<div className="data-dictionary__no-data-found">No Use Case found</div>
	);
}

export function getAttachmentsStatus(status) {
	if (status === true) return "Attachments Required";
	if (status === false) return "Attachments Optional";
	if (status === null) return "No Attachments";
}

export function getDataFieldType(item) {
	return (
		Array.isArray(item?.type) ? (item?.type[0].charAt(0).toUpperCase() + item?.type[0].slice(1))
		: (item?.type.charAt(0).toUpperCase() + item?.type.slice(1))
		+ (item?.format ? ` (${item.format})` : "")
	);
}

export function openAttachment(url) {
	if (url) {
		return window.open(url, "_blank", 'noopener');
	}
}

export function PageTitle(pageTitle) {
	return (
		<div className="data-dictionary__title-header">
			<div className="title-header__left">
				<div className="title-header__title">{pageTitle}</div>
			</div>
		</div>
	);
}

export function prepareFetchParams(
	classification,
	useCasesListing,
	currentPage,
	pageLimit,
	searchDataElement
) {
	const classificationID = classification.includes("All") ? "ALL" : classification?.toUpperCase();
	const useCasesIDList = useCasesListing?.filter((e) => {
		return e.$selected === true;
	});
	const selectedUseCaseListing =
		useCasesIDList?.length === useCasesListing?.length
			? "ALL"
			: useCasesIDList?.map((a) => a.value).toString();
	const useCase = useCasesIDList?.length > 0 ? selectedUseCaseListing : "ALL";
	return `useCaseId=${useCase}&classification=${classificationID}&currentPage=${currentPage}&pageSize=${pageLimit}&searchKey=${searchDataElement}`;
}

export function SubDataElementDetails({ subDetailsItem , isRoot}) {
	return (
		<>
		<div className="data-dictionary__fields-subdata-details__margin">
				{isRoot ?
					(<div className="data-dictionary__fields-data-header">
							<MultiLineText>{subDetailsItem?.description}</MultiLineText>
						</div>)
				:
				(<div className="data-dictionary__fields-data-details_header">
					{subDetailsItem?.description}
				</div>)
				}
			</div>
			<div className="data-dictionary__fields-data-details data-dictionary__fields-subdata-details__margin">
				<div>
					<div className="data-dictionary__fields-data-details_header">
						Applicable Standard Name
					</div>
					<div className="data-dictionary__fields-data-details_data">
						{subDetailsItem?.applicableStandardName}
					</div>
				</div>
				<div>
					<div className="data-dictionary__fields-data-details_header">
						Data Field Type
					</div>
					<div className="data-dictionary__fields-data-details_data">
						{getDataFieldType(subDetailsItem)}
					</div>
				</div>
			</div>
			<div className="data-dictionary__fields-subdata-details__margin">
				<div className="data-dictionary__fields-data-details_header">
					Data Format
				</div>
				<div className="data-dictionary__fields-data-details_data">
					{subDetailsItem?.dataFormat}
				</div>
			</div>
		</>
	);
}
SubDataElementDetails.propTypes ={
	subDetailsItem: PropTypes.object,
	isRoot: PropTypes.bool
}

export function getFieldCount(dictionaryDetails, status) {
	return dictionaryDetails?.fields?.filter((obj) => {
		return obj.isOptional === status;
	}).length;
}

export function getPageStart(pageSize, pageNr) {
	return pageSize * pageNr;
}

export function getPageLabel(total, pageSize, pageNr) {
	const start = Math.max(getPageStart(pageSize, pageNr), 0);
	const end = Math.min(getPageStart(pageSize, pageNr + 1), total);
	return `${start + 1} - ${end}`;
}

export function DataTableHeader() {
	const isTradex = useTradex();

	return (
		<div className="data-table__table__head">
			<div className="data-table__table__head__row">
				<div
					className={`data-table__table__head__title data-table__table__head__title-data__element`}
					id="dataElement"
				>
					Data Element
				</div>
				<div
					className={`data-table__table__head__title data-table__table__head__title-common__details`}
					id="classification"
				>
					Classification
				</div>
				<div
					className={`data-table__table__head__title data-table__table__head__title-description`}
					id="description"
				>
					Description / Definition
				</div>

				{isTradex && (
					<div
						className={`data-table__table__head__title data-table__table__head__title-description`}
						id="applicable"
					>
						Applicable Use Case(s)
					</div>
				)}

				<div
					className={`data-table__table__head__title data-table__table__head__title-common__details`}
					id="dataFields"
				>
					Data Fields
				</div>

				<div className="data-table__table__head__title data-table__table__head__title-common__details"></div>
			</div>
		</div>
	);
}

export function DataTableList({
	data,
	onClick,
}) {
	const isTradex = useTradex();

	if (data?.length > 0) {

		return (
			<>
				{
					data?.map((item) => {
						return (
							<div className="data-table__table__body__rows" key={item.id}>
								<div className="data-table__table__body__contents data-table__table__body__content--heavy data-table__table__body__content-data__element">
									{item.dataElementName}
								</div>
								<div className="data-table__table__body__contents data-table__table__body__content-common__details">
									{item.classification === "DOCUMENT"
										? "Document"
										: "Event"}
								</div>
								<div className="data-table__table__body__contents data-table__table__body__content-description">
									{item.description}
								</div>

								{isTradex && (
									<div className="data-table__table__body__contents data-table__table__body__content-description data-table__table__body__display">
										{item.useCase?.map((useCase) => {
											return (
												<div className="data-table__table__body__content__applicable-header" key={useCase.useCaseId}>
													<Tags label = {useCase.useCaseName} tagClassName='DS__tag--system'/>
												</div>
											);
										})}
									</div>
								)}

								<div className="data-table__table__body__contents data-table__table__body__content-common__details">
									{item.fields}
								</div>
								<div
									className="data-table__table__body__content data-table__table__body__content-common__details"
									style={{ textAlign: "right" }}
								>
									<span
										className="data-table__table__body__view-details"
										id="data-dictionary-view-details"
										onClick={() => onClick(item)}
									>
										View Details
									</span>
								</div>
							</div>
						);
					})
				}
			</>
		)
	}
	return (
		<div className="data-table__empty">
			<NoMessage />
		</div>
	);
}

export function SearchInput({
	searchDataElement,
	setSearchDataElement,
	modalOpen,
}) {
	const handleChange = (e) => {
		setSearchDataElement(e.target.value);
	};
	const handleCancel = () => setSearchDataElement("")
	return (
		<div className="data-table__table__head__row">
			<div className="data-table__table__head__row__left data-table__table__left__width data-table__table__display">

				{
					feature(featureConstant.NEW_DESIGN_SYSTEM) ? (
						<Search value={searchDataElement || ''} placeholder="Search by Data Element" onChange={handleChange} onCancel={handleCancel} />
					) : (
						<>
							<input
								type="text"
								value={searchDataElement || ""}
								onChange={(e) => {
									setSearchDataElement(e.target.value);
								}}
								placeholder="Search by Data Element"
								className="data-table__table__search"
								style={{
									backgroundImage: !searchDataElement
										? `url(${iconSearch})`
										: "",
								}}
								autoFocus={modalOpen ? "" : "autoFocus"}
							/>
							{searchDataElement && (
								<div
									className="data-table__table__close__style"
									onClick={() => setSearchDataElement("")}
								>
									<IconCloseGrey />
								</div>
							)}
						</>
					)
				}
			</div>
		</div>
	);
}

export const DisplayNestedRecursive  =({data, isRoot, type, level}) =>{
	const [expandedIndex, setExpandedIndex] = useState(null);
	const [selectedItem, setSelectedItem] = useState(null);
	const handleExpand  =(index, item)=>{
		setExpandedIndex(index === expandedIndex ? null : index)
		setSelectedItem(item)
	}

	if(!data || data.length === 0){
    return (
      <div className="data-dictionary__no-data-found">
        No Data Field Found
      </div>
    );
  }

	return (
		<div>
			{data.map((item, index) => {
				return filterFields(isRoot, item, type) && <div key={item.id}>
					<div data-testid="nested-sub-level">
						<div className={expandedIndex === index && !item ? `data-dictionary__fields-details__active-border` : ""}>
							<div
								className={expandedIndex === index ? "data-dictionary__fields-details__active" : "data-dictionary__fields-details"}
								onClick={() => handleExpand(index, item)}
							>
								<div>
									{item.title ? item.title : item.description}{isRoot === false && !item.isOptional && " *"}
								</div>
								<div>
									{expandedIndex !== index ? <IconNext /> : <IconDown />}
								</div>
							</div>
						</div>

						{selectedItem && expandedIndex === index && (
							<div >
								<SubDataElementDetails subDetailsItem={selectedItem} isRoot={isRoot} />
								{hasChildren(item) &&
									<div style={{ backgroundColor: bgColors[level] }} className="data-dictionary__fields-data-details data-dictionary__data-details__margin">
										<div className="data-dictionary__fields-sub__heading">
											Sub Data Fields
										</div>
										<div className="data-dictionary__fields-mandatory__field">
											* Mandatory Field
										</div>
									</div>
								}
							</div>
						)}
						<div style={{ backgroundColor: bgColors[level] }}>

							{index === expandedIndex && hasChildren(item) && (<DisplayNestedRecursive data={item.fields} isRoot={false} type={true} level={level + 1} />)}
						</div>
					</div >
				</div>
			})}
		</div>
	)

}

DisplayNestedRecursive.propTypes = {
	data:PropTypes.array,
	isRoot:PropTypes.bool,
	type:PropTypes.bool,
	level:PropTypes.number
}

export const hasChildren = (item) =>  Array.isArray(item.fields) && item.fields.length > 0;
export const filterFields =(isRoot,item, allowOptional) =>isRoot ? item.isOptional === allowOptional : true
